import { render, staticRenderFns } from "./menberCard.vue?vue&type=template&id=706ace03&"
import script from "./menberCard.vue?vue&type=script&lang=js&"
export * from "./menberCard.vue?vue&type=script&lang=js&"
import style0 from "./menberCard.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports